import { riskPerformanceFormatterV1 } from "./riskPerformanceFormatterV1";
import { riskVolatilityFormatterV1 } from "./riskVolatilityFormatterV1";
import { RiskDtoV3 } from "../../../generated-api-v3";
import { AxiosResponse } from "axios";
import { ITimePeriod } from "@iliotech/types";
import moment from "moment-timezone";

export const riskFormatter = (
  volatilityResponseData?: AxiosResponse<RiskDtoV3>,
  period?: ITimePeriod,
  frequency?: "Daily" | "Monthly",
  small?: boolean
) => {
  const annualizationDate =
    new Date(volatilityResponseData?.data?.portfolio?.annualisationEndDate!) >
    new Date()
      ? new Date()
      : volatilityResponseData?.data?.portfolio?.annualisationEndDate;
  return {
    risk: riskPerformanceFormatterV1(
      volatilityResponseData,
      frequency!,
      small ? moment(annualizationDate) : undefined
    ),
    volatility: riskVolatilityFormatterV1(volatilityResponseData, period),
    annualizationDate,
    benchmarkIndexName: volatilityResponseData?.data?.benchmark?.indexName,
  };
};
